module.exports = __webpack_public_path__ + "static/media/cellphone-mockup.2beb8de4.png";